@switch (notice) {
  @case (MultiOrderNotice.NO_LEVERAGED_DERIVATIVES_EXPERIENCE) {
    <ng-container *ngTemplateOutlet="simpleAllowToProceedNotice" />
  }
  @case (MultiOrderNotice.NO_NON_LEVERAGED_DERIVATIVES_EXPERIENCE) {
    <ng-container *ngTemplateOutlet="simpleAllowToProceedNotice" />
  }
  @case (MultiOrderNotice.NO_FTG_BUT_ALLOWED_TO_ACTIVATE) {
    <div class="col-12 mt-4 pt-3 pb-3 border-error">
      <div class="row">
        <div
          data-zid="multi-order-notice-headline"
          class="col-12 font-bold"
          [innerHTML]="'trade.multi-order.create.notice.' + notice + '.headline' | transloco"
        ></div>
      </div>
      <div class="row">
        <div data-zid="multi-order-notice-text" class="col-12 mb-3 text-size-large">
          {{ 'trade.multi-order.create.notice.' + notice + '.text' | transloco }}
          <br />
          Diese kannst du im
          <a [routerLink]="commonRoutes.postlogin.verwaltung" class="link text-info link-underline">Verwaltungs&shy;bereich</a>
          Abschnitt <strong>"Depot"</strong> aktivieren
        </div>
      </div>
    </div>
  }
  @case (MultiOrderNotice.NO_FTG) {
    <div class="col-12 mt-4 pt-3 pb-3 border-error">
      <div class="row">
        <div
          data-zid="multi-order-notice-headline"
          class="col-12 font-bold"
          [innerHTML]="'trade.multi-order.create.notice.' + notice + '.headline' | transloco"
        ></div>
      </div>
      <div class="row">
        <div data-zid="multi-order-notice-text" class="col-12 mb-3 text-size-large">
          {{ 'trade.multi-order.create.notice.' + notice + '.text' | transloco }}
          <br />
          Wende Dich bitte per Ticket an den
          <a [routerLink]="commonRoutes.postlogin.tickets" class="link text-info link-underline">Kundenservice.</a>
        </div>
      </div>
    </div>
  }
}

<ng-template #simpleAllowToProceedNotice>
  <div class="col-12 mt-4 pt-3 pb-3 border-attention">
    <div class="row">
      <div data-zid="multi-order-notice-headline" class="col-12 font-bold">
        {{ 'trade.multi-order.create.notice.' + notice + '.headline' | transloco }}
      </div>
    </div>
    <div class="row">
      <div data-zid="multi-order-notice-text" class="col-12 mb-3 text-size-large">
        {{ 'trade.multi-order.create.notice.' + notice + '.text' | transloco }}
      </div>
      <div class="col-6"></div>
      <div class="col-6 d-flex justify-content-end">
        <web-design-system-button data-zid="multi-order-notice-btn" size="small" (click)="proceed.emit()">
          {{ 'trade.multi-order.create.notice.' + notice + '.btn' | transloco }}
        </web-design-system-button>
      </div>
    </div>
  </div>
</ng-template>
